export const init = () => {}
export const captureException = () => {}
export const captureMessage = () => {}